export const TOGGLE_POPUP = 'questionnairePT/TOGGLE_POPUP';
export const SET_PRODUCT_TYPE = 'questionnairePT/SET_PRODUCT_TYPE';

export const REQUEST = 'questionnairePT/REQUEST';
export const FAILURE = 'questionnairePT/FAILURE';

export const GET_QUESTIONS_SUCCESS = 'questionnairePT/GET_QUESTIONS_SUCCESS';
export const SEND_ANSWERS_SUCCESS = 'questionnairePT/SEND_ANSWERS_SUCCESS';
export const GET_PRODUCT_TYPES_SUCCESS = 'questionnairePT/GET_PRODUCT_TYPES_SUCCESS';
